import axios from "axios";
import { AllUrl } from "./ServiceConstants";
import { CatchMessage, handleGetValidFormDataValue } from "../Shared/Methods";

const instance = axios.create({
  baseURL: window.appConfig.BASE_URL,
});

// instance.interceptors.response.use(async (response) => {
//   let token = getCookie("MconnectEnergyLoginData");

//   // if (token) {
//   //   request.headers["Authorization"] = `bearer ${
//   //     JSON.parse(token)?.access_token
//   //   }`;
//   // }
//   const dispatch=useDispatch()

//   return response
// });

instance.interceptors.request.use(
  (request) => {
    if (request?.data instanceof FormData) {
      request.data = handleGetValidFormDataValue(request?.data);
    }

    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    if (response?.data?.status === -1) {
      // handleLogout(1);
    }
    return response;
  },
  function (error) {
    CatchMessage(error);
  }
);

export default instance;
